import { generatePercentColor } from "../../../utils";
import { ProgressBarProps } from "../../../constants/statistics";
import React from "react";
// ₽
const ProgressBar: React.FC<ProgressBarProps> = ({
  fact,
  target,
  startDate,
  endDate,
}) => {
  // Текущая дата
  const today = new Date();

  // Вычисление общего количества дней в текущем месяце
  const getDaysInMonth = (year: number, month: number) => {
    return new Date(year, month + 1, 0).getDate();
  };
  const daysInMonth = getDaysInMonth(today.getFullYear(), today.getMonth());

  // Вычисление количества прошедших дней в текущем месяце
  const daysPassed = today.getDate();

  // Отношение факта к цели
  const ratio = fact / target;
  const progress = Math.round(ratio * 100);

  // Цвета для градиента
  const minRatio = generatePercentColor(ratio * 0.9);
  const maxRatio = generatePercentColor(ratio * 1.1);
  const gradient = `
    linear-gradient(135deg, rgba(${minRatio.r}, ${minRatio.g}, ${minRatio.b}, 0.8), 
    rgba(${maxRatio.r}, ${maxRatio.g}, ${maxRatio.b}, 0.4))`;

  // Ширина полосы прогресса на основе пройденных дней
  const progressWidth = (daysPassed / daysInMonth) * 100;

  return (
    <div
      style={{
        marginTop: 24,
        fontFamily: "SF Pro Display",
        fontSize: "12px",
        color: "#ABABAB",
      }}
    >
      {/* Полоса прогресса */}
      <div style={{ position: "relative", width: "100%", height: "30px" }}>
        {/* Фон полосы */}
        <div
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "2px",
            backgroundColor: "#F5F5F5",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
        {/* Заполненная часть */}
        <div
          style={{
            width: `${Math.min(progressWidth, 100)}%`,
            height: "100%",
            borderRadius: "2px",
            background: gradient,
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
      </div>

      {/* Линии разделения */}
      <div style={{ position: "relative", height: "19px", marginTop: "8px" }}>
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            style={{
              position: "absolute",
              left: `${(index * 82.7778).toFixed(2)}px`,
              width: "1px",
              height: "100%",
              backgroundColor: "#E0E0E0",
            }}
          />
        ))}
      </div>

      {/* Текстовые метки */}
      <div className="flex between" style={{ marginTop: "8px" }}>
        <span className="eventDateInfo">{startDate}</span>
        <span className="eventDateInfo">{endDate}</span>
      </div>
      <div className="flex between diageamLegend gap10" style={{ marginTop: 24 }}>
        <div
          className="legendItem"
          style={{
            background: "#F0FBFE",
            borderLeft: "4px solid #3E90F0",
            padding: "12px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 10,
            width: 'calc(32% - 5px)',
            color: '#161032'
          }}
        >
          <div className="text">Выполнено</div>
          <div className="text" style={{
            fontSize: 28,
            fontWeight: 300
          }}>
            {`${fact.toLocaleString('ru-RU')}`} <span style={{ color: "#ABABAB" }}>$</span>
          </div>
        </div>
        <div
          className="legendItem"
          style={{
            background: "#F0F2F4",
            borderLeft: "4px solid #ABABAB",
            padding: "12px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 10,
            width: 'calc(32% - 5px)',
            color: '#161032'
          }}
        >
          <div className="text">Осталось</div>
          <div className="text" style={{
            fontSize: 28,
            fontWeight: 300
          }}>
            {`${(Math.max(target - fact, 0))?.toLocaleString('ru-RU')}`} <span style={{ color: "#ABABAB" }}>$</span>
          </div>
        </div>
        <div
          className="legendItem"
          style={{
            background: `rgba(${minRatio.r}, ${minRatio.g}, ${minRatio.b}, 0.2)`,
            borderLeft: `4px solid rgba(${maxRatio.r}, ${maxRatio.g}, ${maxRatio.b})`,
            padding: "12px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 10,
            width: 'calc(32% - 5px)',
            color: '#161032'
          }}
        >
          <div className="text">Выполнение плана</div>
          <div className="text" style={{
            fontSize: 28,
            fontWeight: 300
          }}>
            {progress} <span style={{ color: "#ABABAB" }}>%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;